import React from "react";
import cn from "classnames";
import styles from "./LongevityScore.module.sass";

const LongevityScore = ({
    score = 99,
    label = "Health Conscious",
    animalName = "The Tiger",
    animalImage = "/images/zova/animals/tiger.svg",
    description = [
        "Like the panther, you move with strength, agility, and purpose.",
        "Your dedication to health shows that you are intentional about your well-being,",
        "which will set you apart in the long run.",
        "However, even the strongest animals need the right environment to thrive—small",
        "refinements can help you unlock even greater vitality and resilience."
    ]
}) => {
    return (
        <div className={cn("section-bg", styles.section)}>
            <div className={cn("container", styles.container)}>
                <div className={styles.content}>
                    <div className={styles.scoreSection}>
                        <h1 className={styles.title}>Your Zova longevity score:</h1>
                        <div className={styles.scoreWrapper}>
                            <div className={styles.score}>{score}%</div>
                            <div className={styles.label}>{label}</div>
                        </div>
                    </div>

                    <div className={styles.avatarSection}>
                        <div className={styles.avatarContent}>
                            <div className={styles.avatarImage}>
                                <img src={animalImage} alt={`Longevity Avatar - ${animalName}`} />
                            </div>
                            <div className={styles.avatarTitle}>
                                <span>Your Longevity Avatar</span>
                                <span className={styles.avatarName}>{animalName}</span>
                            </div>
                        </div>
                    </div>

                    <div className={styles.description}>{description}</div>
                </div>
            </div>
        </div>
    );
};

export default LongevityScore; 